<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary200, primary } = $AppState.theme.colors;

  export let color1 = primary;
  export let color2 = primary200;
</script>

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12 0.750001C5.7868 0.750001 0.749999 5.7868 0.749999 12C0.749998 18.2132 5.78679 23.25 12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.750002 12 0.750001Z"
    stroke="url(#paint0_linear_1403_29111)"
    stroke-width="1.5"
  />
  <path
    d="M13.251 16L9.25098 12L13.251 8"
    stroke="url(#paint1_linear_1403_29111)"
    stroke-width="1.86667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1403_29111"
      x1="55"
      y1="4.78379"
      x2="52.3413"
      y2="28.908"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={color2} />
      <stop offset="1" stop-color={color1} />
    </linearGradient>
    <linearGradient
      id="paint1_linear_1403_29111"
      x1="18.4176"
      y1="9.59459"
      x2="16.7068"
      y2="17.3566"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={color2} />
      <stop offset="1" stop-color={color1} />
    </linearGradient>
  </defs>
</svg>
